/* ==========================================================================
   InstaCuppa PDP â€” per-variant image filtering (alt-text driven)
   Scoped to a known set of PRODUCT IDs (stable) â€” NOT handles.

   Enabled products (each keys off ONE option; values matched from image alt):
     â€¢ 1403210432590 â€” Insulated Water Bottle 1000 ml Â· Color: Black/Navy Blue/Sky Blue/Red/Yellow
     â€¢ 4027979432014 â€” Stainless Steel French Press   Â· Color: Black/Classic/Copper
     â€¢ 9440681820441 â€” Mini Desk Vacuum Cleaner        Â· Model: Battery Edition/Rechargeable Edition
     â€¢ 4724334559310 â€” Borosilicate Glass Water Bottle 1 L Â· Color: 7 colours (+ Size option)

   Decision from each image's ALT text: the variant value is read from the
   DELIMITED slot "â€¦brand + keywordâ€¦ - {Value} - â€¦" OR the " â€“ {Value}" suffix
   (split on space+dash+space, any dash). Fallback = longest-value-first
   substring. Untagged = shared (always shown, e.g. a video). If NO image is
   tagged, do nothing (native theme behavior).
   ========================================================================== */
(function () {
  var PRODUCTS = {
    // Battery Milk Frother with Stand - 9 colours (+ a single-value Size option). Gallery 2026-09-26:
    // 9 slides per colour in order Black (pos 1-9), Red, Pink, Green, Rose Gold, White, Blue, Silver
    // (72 images), then the product video (untagged = shared). Alts:
    // 'InstaCuppa Milk Frother with Stand - {Colour} - desc · 4 whisks'. Yellow is sold out and has
    // NO images, so aliasValues shows the Black deck when Yellow is selected.
    '333211402268': {
      optionName: 'Color',
      fallbackValues: ['Black', 'Red', 'Pink', 'Green', 'Rose Gold', 'White', 'Blue', 'Yellow', 'Silver'],
      variantValue: { '12499483852878': 'Black', '4343987863580': 'Red', '31154943623246': 'Pink', '31154920882254': 'Green', '31154938445902': 'Rose Gold', '31154933694542': 'White', '32601360760910': 'Blue', '39246596145230': 'Yellow', '39257659310158': 'Silver' },
      aliasValues: { 'Yellow': 'Black' }
    },

    // Fruit Infuser Water Bottle 1 L (Tritan) - 5 colours x 2 sizes (6 variants). Gallery 2026-09-26:
    // 9 Black (pos 1-9), 9 Rose (10-18), 9 Blue (19-27), 9 Green (28-36), then the unboxing video
    // (untagged, colour-free alt = shown for every colour) and Purple's single pack shot (Purple is
    // out of stock). Alts: 'InstaCuppa Fruit Infuser Water Bottle 1 Litre - {Colour} - desc'.
    // Black / 700 ML shares the Black deck. Never put Black/Rose/Blue/Green/Purple in a colour-free alt.
    '10280572425': {
      optionName: 'Color',
      fallbackValues: ['Black', 'Rose', 'Blue', 'Green', 'Purple'],
      variantValue: { '21189017108558': 'Black', '31267423092814': 'Black', '43383860041': 'Rose', '29270782771278': 'Blue', '29270770614350': 'Green', '29270818127950': 'Purple' }
    },

    // Espresso Puck Screen - ONE product, two sizes. Only the hero (pos 1/2) and the spec
    // sheet (pos 9/10) differ by size; the other seven scenes are generic and stay
    // UNTAGGED so they show on both. Alts: 'InstaCuppa Espresso Puck Screen - 51 mm - ...'
    // for the size-specific ones, no size slot on the shared ones. Asserted in
    // Listing Images/puck-screen/gen/shopify_merge.py before upload.
    '10782277173529': {
      optionName: 'Size',
      fallbackValues: ['51 mm', '58 mm'],
      variantValue: { '53085645701401': '51 mm', '53085645734169': '58 mm' }
    },

    // Coffee Canister 500g - gallery is 9 Steel slides (pos 1-9) then 9 Black (10-18).
    // NOTE the colour value 'Steel' also occurs as a MATERIAL word in descriptors
    // ('stainless steel'), so the delimited ' - Colour - ' slot MUST stay intact on every
    // alt; the substring fallback would mis-tag Black images. Alts asserted in push_shopify.py.
    '4867238199374': {
      optionName: 'Color',
      fallbackValues: ['Black', 'Steel'],
      variantValue: { '39421730029646': 'Steel', '39421729996878': 'Black' }
    },
    // Electric Moka Pot 300ml - gallery is 9 Black slides (pos 1-9) then
    // 9 Silver (pos 10-18); filtering keys off the ' - Colour - ' alt slot.
    '6834329944142': {
      optionName: 'Color',
      fallbackValues: ['Black', 'Silver'],
      variantValue: { '40087762829390': 'Black', '51771774075161': 'Silver' }
    },
    // Foldable Silicone Kettle 600 ml - ONE product, option 'Size' (dropdown): 'Foldable Electric Kettle' (V1, red switch)
    // and 'Temperature Control Edition' (V2, dial). Gallery 2026-10-24: 9 V1 slides (pos 1-9) then 9 V2 (10-18).
    // Alts end with the delimited slot ' - {Value}' (e.g. '... folded flat side by side - Foldable Electric Kettle').
    // V1's value is a substring of generic V2 wording, so the delimited slot MUST stay on every alt (content.py asserts it).
    '8460860555545': {
      optionName: 'Size',
      fallbackValues: ["Foldable Electric Kettle", "Temperature Control Edition"],
      variantValue: {"45718428582169": "Foldable Electric Kettle", "47813433426201": "Temperature Control Edition"}
    },
    '1403210432590': {
      optionName: 'Color',
      fallbackValues: ['Black', 'Navy Blue', 'Sky Blue', 'Red', 'Yellow'],
      variantValue: { '32318283743310': 'Black', '32601301057614': 'Navy Blue', '39421733208142': 'Sky Blue', '67633456382233': 'Red', '67633456415001': 'Yellow' }
    },
    '4027979432014': {
      optionName: 'Color',
      fallbackValues: ['Black', 'Classic', 'Copper'],
      variantValue: { '30154260381774': 'Black', '29677542735950': 'Classic', '30154260349006': 'Copper' }
    },
    '9440681820441': {
      optionName: 'Model',
      fallbackValues: ['Battery Edition', 'Rechargeable Edition'],
      variantValue: { '48900176019737': 'Battery Edition', '52796181381401': 'Rechargeable Edition' }
    },
    '6679233101902': {
      optionName: 'Pack',
      fallbackValues: ['Pack of 1', 'Pack of 2'],
      variantValue: { '39588768219214': 'Pack of 2', '52818424234265': 'Pack of 1' }
    },
    '6628414423118': {
      optionName: 'Color',
      fallbackValues: ['Black', 'Silver', 'Red'],
      variantValue: { '39441409671246': 'Black', '39441409704014': 'Silver', '47147155030297': 'Red' }
    },
    // Borosilicate Glass Water Bottle 1 Litre - 7 colours x 2 sizes (14 variants).
    // Gallery: 9 Black (pos 1-9), 9 Pink (10-18), then hero-only Grey/Red/Green/Yellow/Blue
    // (19-23) - those five are out of stock, so Saran asked for hero only.
    // NOTE this is the first enabled product with a SECOND option (Size). optionBlock()
    // matches the legend text /colou?r/i so the Size block is ignored; variantValue maps
    // ALL 14 ids because both sizes share a colour hero.
    '4724334559310': {
      optionName: 'Color',
      fallbackValues: ['Black', 'Grey', 'Red', 'Green', 'Yellow', 'Pink', 'Blue'],
      variantValue: { '32878682374222': 'Black', '39264641318990': 'Grey', '39264641515598': 'Red', '39264641712206': 'Green', '39264641777742': 'Yellow', '39264641843278': 'Pink', '39264641908814': 'Blue', '39351069671502': 'Black', '39351072096334': 'Grey', '39351072653390': 'Red', '39351073603662': 'Green', '39351074488398': 'Yellow', '39351075078222': 'Pink', '39351078584398': 'Blue' }
    },
    '3959162503246': {
      optionName: 'Color',
      fallbackValues: ['Clear', 'Copper', 'Black'],
      variantValue: { '29454569209934': 'Clear', '30154232004686': 'Copper', '30154228105294': 'Black' }
    },

    // Aero French Press (2026-10-25) - Color (Clear=Steel/Black/Copper) x Size (350/600/1000 ML), 9 variants.
    // Gallery: 27 new 600 ML slides (9 per colour) tagged ' - {Color} 600 ML - ', then the 2020 images (untagged,
    // shared by the 350 / 1000 ML sizes) and the video. legacyFor: untagged IMAGES show only for these values,
    // so a 600 ML colour shows only its own 9 + the video, and 350 / 1000 ML keep today's gallery.
    '1398797926478': {
      optionNames: ['Color', 'Size'],
      fallbackValues: ["Clear 350 ML", "Clear 600 ML", "Clear 1000 ML", "Black 350 ML", "Black 600 ML", "Black 1000 ML", "Copper 350 ML", "Copper 600 ML", "Copper 1000 ML"],
      variantValue: {"39571464061006": "Clear 350 ML", "30154239049806": "Clear 600 ML", "39339141529678": "Clear 1000 ML", "39571469008974": "Black 350 ML", "12498314264654": "Black 600 ML", "39339142545486": "Black 1000 ML", "39571469107278": "Copper 350 ML", "30154239017038": "Copper 600 ML", "39339143626830": "Copper 1000 ML"},
      legacyFor: ["Clear 350 ML", "Clear 1000 ML", "Black 350 ML", "Black 1000 ML", "Copper 350 ML", "Copper 1000 ML"]
    },

    // Motivational Water Bottle 1 L - Size (single value '1000 ML', option 1) x Color (Black/Pink, option 2).
    // Gallery 2026-10-03: 8 Black slides (pos 1-8), 8 Pink (9-16), then the product video (colour-free
    // alt = shown for both). Alts: 'InstaCuppa Motivational Water Bottle 1 Litre - {Colour} - desc'.
    // optionBlock() matches the Color legend, so the Size block is ignored. Never put Black/Pink in a
    // colour-free alt or outside the slot (the Pink deck's sleeve is dark - say 'sleeve', not its colour).
    '6835994263630': {
      optionName: 'Color',
      fallbackValues: ['Black', 'Pink'],
      variantValue: { '40094784618574': 'Black', '45454253621529': 'Pink' }
    },

    // Rechargeable Mini Electric Chopper - FIRST TWO-AXIS product (Size x Color).
    // Gallery: 9 slides per size-colour deck (36 total). Alt slot carries the COMBINED
    // value "250 ML White" etc: "InstaCuppa Mini Electric Chopper - {Size} {Color} - desc".
    // optionNames (plural) makes valueList/selectedValue join both blocks with a space.
    '6648118607950': {
      optionNames: ['Size', 'Color'],
      fallbackValues: ['250 ML White', '250 ML Black', '350 ML White', '350 ML Black'],
      variantValue: { '39687023657038': '250 ML White', '49639153107225': '250 ML Black', '39687023722574': '350 ML White', '51690572644633': '350 ML Black' }
    }
  };

  function thisProductId() {
    var el = document.querySelector('[data-product-id]');
    if (el && el.getAttribute('data-product-id')) return el.getAttribute('data-product-id');
    try { if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) return String(ShopifyAnalytics.meta.product.id); } catch (e) {}
    return null;
  }
  function config() { return PRODUCTS[thisProductId()] || null; }

  // find the .product-form__input block for this product's keyed option
  function optionBlock(cfg, nameArg) {
    var name = nameArg || cfg.optionName || 'Color';
    var re = name.toLowerCase() === 'color' ? /colou?r/i : new RegExp(name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i');
    var blocks = document.querySelectorAll('.product-form__input');
    for (var i = 0; i < blocks.length; i++) {
      var lbl = blocks[i].querySelector('legend, label');
      if (lbl && re.test(lbl.textContent)) return blocks[i];
    }
    return null;
  }
  function blockValues(block) {
    var out = [];
    if (block) {
      block.querySelectorAll('input[type="radio"]').forEach(function (r) { if (r.value) out.push(r.value.trim()); });
      var sel = block.querySelector('select');
      if (sel) Array.prototype.forEach.call(sel.options, function (o) { if (o.value) out.push(o.value.trim()); });
    }
    return out;
  }
  function valueList(cfg) {
    if (cfg.optionNames) {
      var lists = cfg.optionNames.map(function (n) { return blockValues(optionBlock(cfg, n)); });
      if (lists.every(function (l) { return l.length; })) {
        var combos = [''];
        lists.forEach(function (l) {
          var next = [];
          combos.forEach(function (c) { l.forEach(function (v) { next.push(c ? c + ' ' + v : v); }); });
          combos = next;
        });
        return combos;
      }
      return cfg.fallbackValues.slice();
    }
    var block = optionBlock(cfg), out = [];
    if (block) {
      block.querySelectorAll('input[type="radio"]').forEach(function (r) { if (r.value) out.push(r.value.trim()); });
      var sel = block.querySelector('select');
      if (sel) Array.prototype.forEach.call(sel.options, function (o) { if (o.value) out.push(o.value.trim()); });
    }
    return out.length ? out : cfg.fallbackValues.slice();
  }
  function selectedBlockValue(block) {
    if (!block) return null;
    var chk = block.querySelector('input:checked'); if (chk && chk.value) return chk.value.trim();
    var sel = block.querySelector('select'); if (sel && sel.value) return sel.value.trim();
    return null;
  }
  function selectedValue(cfg) {
    if (cfg.optionNames) {
      var parts = cfg.optionNames.map(function (n) { return selectedBlockValue(optionBlock(cfg, n)); });
      if (parts.every(function (v) { return v; })) return parts.join(' ');
      var idEl2 = document.querySelector('form[action*="/cart/add"] [name="id"], product-form [name="id"], .product-form [name="id"]');
      if (idEl2 && cfg.variantValue[idEl2.value]) return cfg.variantValue[idEl2.value];
      return null;
    }
    var block = optionBlock(cfg);
    if (block) {
      var chk = block.querySelector('input:checked'); if (chk && chk.value) return chk.value.trim();
      var sel = block.querySelector('select'); if (sel && sel.value) return sel.value.trim();
    }
    var idEl = document.querySelector('form[action*="/cart/add"] [name="id"], product-form [name="id"], .product-form [name="id"]');
    if (idEl && cfg.variantValue[idEl.value]) return cfg.variantValue[idEl.value];
    return null;
  }

  // which value (if any) an image's alt text belongs to
  function imageValue(li, values) {
    var img = li.querySelector('img[alt]'); if (!img) return null;
    var alt = img.getAttribute('alt') || '';
    // 1) delimited: "prefix - VALUE - â€¦" or "â€¦ â€“ VALUE" (split on space+dash+space)
    var parts = alt.split(/\s[-â€“â€”]\s/);
    for (var p = 1; p < parts.length; p++) {
      var tok = parts[p].trim().toLowerCase();
      for (var i = 0; i < values.length; i++) if (tok === values[i].toLowerCase()) return values[i];
    }
    // 2) fallback: longest value first so a multi-word value wins over a substring
    var byLen = values.slice().sort(function (a, b) { return b.length - a.length; });
    var low = alt.toLowerCase();
    for (var j = 0; j < byLen.length; j++) if (low.indexOf(byLen[j].toLowerCase()) !== -1) return byLen[j];
    return null; // shared / untagged
  }

  function apply() {
    var cfg = config(); if (!cfg) return;
    var values = valueList(cfg);
    var selected = selectedValue(cfg);
    if (!selected) return;
    // a value with no images of its own (e.g. a sold-out colour) borrows another value's set
    if (cfg.aliasValues && cfg.aliasValues[selected]) selected = cfg.aliasValues[selected];
    var items = document.querySelectorAll('.product__media-item, .thumbnail-list__item');
    if (!items.length) return;

    var anyTagged = false;
    for (var k = 0; k < items.length; k++) { if (imageValue(items[k], values)) { anyTagged = true; break; } }
    if (!anyTagged) return;

    var sig = '', visibleMain = 0;
    items.forEach(function (li) {
      var c = imageValue(li, values);
      var hide = c && c.toLowerCase() !== selected.toLowerCase();
      // legacyFor (opt-in per product): untagged IMAGES are only for the listed values; videos/models stay shared
      if (!c && cfg.legacyFor && !li.classList.contains('product__media-item--full') && !li.querySelector('.thumbnail__badge')) {
        hide = cfg.legacyFor.map(function (x) { return x.toLowerCase(); }).indexOf(selected.toLowerCase()) === -1;
      }
      if (hide) { li.style.setProperty('display', 'none', 'important'); li.classList.remove('is-active'); }
      else { li.style.removeProperty('display'); if (li.classList.contains('product__media-item')) visibleMain++; }
      sig += hide ? '1' : '0';
    });
    document.querySelectorAll('.slider-counter--total').forEach(function (t) { t.textContent = visibleMain; });

    if (sig !== window.__cvSig) {
      window.__cvSig = sig;
      clearTimeout(window.__cvRz);
      window.__cvRz = setTimeout(function () {
        window.dispatchEvent(new Event('resize'));
        document.querySelectorAll('.slider-counter--total').forEach(function (t) { t.textContent = visibleMain; });
      }, 120);
    }
  }

  if (!config()) return; // CX 2026-10-02: no observers/intervals on products without variant-image config
  document.addEventListener('DOMContentLoaded', apply);
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form__input, form[action*="/cart/add"]')) setTimeout(apply, 60);
  });
  try { new MutationObserver(function () { clearTimeout(window.__cvImg); window.__cvImg = setTimeout(apply, 90); }).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
  var n = 0, iv = setInterval(function () { n++; apply(); if (n > 25) clearInterval(iv); }, 300);
})();
